// Label field that automatically saves the file label as you type
import React from "react";
import linkifyHtml from "linkify-html";
import NoteTextarea from "./NoteTextarea";

import styles from "./Notes.scss";

const timestamp = (item) => {
  const date = new Date(item.created_at);
  const time = date.toLocaleString();
  return `created at ${time} by ${item.user_name}`;
};

export default class NoteItem extends React.Component {
  handleToggleArchive = (e) => {
    e.preventDefault();
    const { item } = this.props;
    this.props.onToggleArchive(item.id || item.uuid);
  };

  handleChange = (val) => {
    console.log("change val noteitem", val);
    const { item } = this.props;
    this.props.onChange(val, item.id || item.uuid);
  };

  render() {
    const { item } = this.props;
    const linkified = linkifyHtml(item.body, { target: "_blank" });
    const toggleIcon = item.archived ? "💫" : "❌";
    const isEditable = !item.created_at && !item.archived;

    return (
      <div className={styles.item}>
        <button className={styles.remove} onClick={this.handleToggleArchive}>
          {toggleIcon}
        </button>
        <div className={styles.body}>
          {isEditable && (
            <NoteTextarea
              value={item.body || ""}
              onUpdate={this.handleChange}
            />
          )}

          {!isEditable && (
            <>
              <div
                className={styles.itemBody}
                dangerouslySetInnerHTML={{ __html: linkified }}
              />
              {!!item.created_at && (
                <div className={styles.timestamp}>{timestamp(item)}</div>
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}
